import { loadAuthorizationJwtTokenFromLocalStorage } from './localStorageHelper';

export const getUserSessionData = () => {
  try {
    const token = loadAuthorizationJwtTokenFromLocalStorage();
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); // eslint-disable-line prefer-template
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (err) {
    console.log(`Error ocured during gettin user session! ${err}`); // eslint-disable-line no-console

    return null;
  }
};

export const isUserLoggedIn = () => (!!loadAuthorizationJwtTokenFromLocalStorage());
